import {getColor, smoothScroll} from '@startlibs/utils';
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components';
import {MEDICARE} from '../../enums/InsuranceType'
import {QuestionList} from '../../components/QuestionList'
import { Insurance } from '../forms/Insurance';
import { Errors } from '@startlibs/form';
import { IntakeFormCard } from './PatientDetailsNew';
import { useIntl } from 'react-intl';


export const OptionalHeading = styled.span`
  color: ${getColor('gray180')};
  font-weight: 400;
`

export const InsuranceDetailsNew = ({title, subTitle, scrollTo, readOnly, form, NavigationButtons}) => {
  const intl = useIntl()
  
  const headerRef = useRef()
  useEffect(() => {
    if (scrollTo) {
      smoothScroll({ target: headerRef.current, offset: -200 })
    }
  }, [])

  return <>
    <IntakeFormCard>
      <div>
        {title && <h3 ref={headerRef}>{title}</h3>}
        {subTitle && <p>{subTitle}</p>}
        <QuestionList
          disabled={readOnly}
          hardLimit={3}
          min={0}
          getEmpty={() => ({id: Date.now(), type: MEDICARE})}
          path="patientInfo.insurances"
          addLabel={intl.formatMessage({
            defaultMessage: "Add insurance",
            description: "InsuranceDetailsNew add insurance button"
          })}
        >{(insurance, i, _arr) => <Insurance
          form={form}
          i={i}
          path={["patientInfo","insurances"]}
          disabled={readOnly}
          canRemove
        />
        }</QuestionList>
      </div>
      <Errors path={'patientInfo.insurances'}/>
      <NavigationButtons />
    </IntakeFormCard>
    {/* <p>
      Note: While some facilities may use this information if there is a
      reimbursable service provided, certain facilities will only collect
      an all-inclusive fee directly from the patient for this service.
      Please check with your facility for details.
    </p> */}
  </>
}
